import { render, staticRenderFns } from "./SchoolReport.vue?vue&type=template&id=333ee414&scoped=true&"
import script from "./SchoolReport.vue?vue&type=script&lang=js&"
export * from "./SchoolReport.vue?vue&type=script&lang=js&"
import style0 from "./SchoolReport.vue?vue&type=style&index=0&id=333ee414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333ee414",
  null
  
)

export default component.exports